module.exports = __webpack_public_path__ + "assets/img/TrendingNow_event.634a704e-ps.jpg";